import { balanceAges } from "../../balanceMap";
import { toReadonlySet } from "utils/sets";
import type { BalanceAge } from "api/responses";
import type { BulkRequestSearchParams, BulkRequestSearchParamsQuery } from "routes/history/bulk-request";

const agings = toReadonlySet(balanceAges);

/** Initial bulk request filtering state. */
export const bulkRequestFilterInitialState: BulkRequestSearchParams = Object.freeze({
    agings: agings,
    minBalanceEnabled: false,
    minBalance: null,
    patient: "",
    excludeOutstandingClaims: true,
    excludeActivePaymentPlans: true,
    excludeMedicaid: true,
});

export const bulkRequestFilterInitialQueryState: BulkRequestSearchParamsQuery = Object.freeze({
    ...bulkRequestFilterInitialState,
    agings: agings as unknown as BalanceAge[],
});

export const bulkRequestFilterClearedState: BulkRequestSearchParamsQuery = Object.freeze({
    agings: agings as unknown as BalanceAge[],
    minBalanceEnabled: false,
    minBalance: null,
    patient: "",
    excludeOutstandingClaims: false,
    excludeActivePaymentPlans: false,
    excludeMedicaid: false,
});
